var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Button, DropdownBase, Icon, InputControl, ModalBase, TextField } from '@/components';
import { IdentityService } from '@/services';
import { useUI } from '@/store';
import { ResolveDate, timeZoneName } from '@/utils';
export const SignatureModal = ({ config, initialSignature, isOpen, onCancel, onConfirm, submittedBy }) => {
    const { withLoading } = useUI();
    const [showPassword, setShowPassword] = useState(false);
    const [payload, setPayload] = useState({
        name: '',
        password: '',
        reason: null,
        username: ''
    });
    const isValid = Boolean(payload.reason) &&
        payload.name.trim().length > 0 &&
        payload.username.trim().length > 0 &&
        payload.password.length > 0 &&
        submittedBy.length > 0;
    useEffect(() => {
        var _a, _b;
        if (!isOpen)
            return;
        setPayload({
            name: (_a = initialSignature === null || initialSignature === void 0 ? void 0 : initialSignature.name) !== null && _a !== void 0 ? _a : '',
            reason: (_b = config.reasons.find((r) => r.value === (initialSignature === null || initialSignature === void 0 ? void 0 : initialSignature.reason))) !== null && _b !== void 0 ? _b : null,
            password: '',
            username: ''
        });
        setShowPassword(false);
    }, [isOpen]);
    const setField = (key, value) => {
        setPayload((current) => (Object.assign(Object.assign({}, current), { [key]: value })));
    };
    const handleConfirm = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (!isValid)
            return;
        try {
            yield withLoading(() => __awaiter(void 0, void 0, void 0, function* () {
                const signedAt = new Date();
                const { signature_id } = yield IdentityService.signSignature({
                    context: payload.reason.label,
                    password: payload.password,
                    reason: payload.reason.value,
                    username: payload.username.trim()
                });
                onConfirm({
                    name: payload.name.trim(),
                    reason: payload.reason.value,
                    reason_label: payload.reason.label,
                    signature_id,
                    signed_at: `${new ResolveDate().formatDateLocalized(signedAt).date_time} (${timeZoneName()})`,
                    signed_at_iso: signedAt.toISOString(),
                    user_id: submittedBy
                });
            }));
        }
        catch (_a) { }
    });
    return (_jsx(ModalBase, Object.assign({ isOpen: isOpen, title: config.title, onClose: onCancel, footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onClick: onCancel, variant: 'outline' }, { children: config.cancelLabel })), _jsx(Button, Object.assign({ isDisabled: !isValid, onClick: handleConfirm }, { children: config.confirmLabel }))] }) }, { children: _jsxs(VStack, Object.assign({ align: 'stretch', spacing: '4', textAlign: 'left', as: 'form', onSubmit: handleConfirm }, { children: [_jsx(InputControl, Object.assign({ label: config.nameLabel }, { children: _jsx(TextField, { autoComplete: 'name', onChange: (e) => setField('name', e.target.value), value: payload.name }) })), _jsx(InputControl, Object.assign({ label: config.reasonLabel }, { children: _jsx(DropdownBase, { "aria-label": config.reasonLabel, getOptionLabel: (option) => option.label, getOptionValue: (option) => String(option.value), onChange: (option) => setField('reason', option), options: config.reasons, placeholder: config.noSelectionText, value: payload.reason }) })), _jsx(InputControl, Object.assign({ label: config.usernameLabel }, { children: _jsx(TextField, { autoComplete: 'username', onChange: (e) => setField('username', e.target.value), value: payload.username }) })), _jsx(InputControl, Object.assign({ label: config.passwordLabel }, { children: _jsx(TextField, { type: showPassword ? 'text' : 'password', value: payload.password, autoComplete: 'current-password', leftElement: _jsx(Icon, { name: 'padlock' }), onChange: (e) => setField('password', e.target.value), rightElement: _jsx(Icon, { cursor: 'pointer', name: showPassword ? 'eye-slash' : 'eye', onClick: () => setShowPassword((prev) => !prev) }) }) }))] })) })));
};
